export default "__VITE_ASSET__CSPPlVRX__"